// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IUserCommunicationConfigurationInfoDto
 */
export interface IUserCommunicationConfigurationInfoDto {
    /**
     * 
     * @type {Set<string>}
     * @memberof IUserCommunicationConfigurationInfoDto
     */
    communication_config_channels?: Set<IUserCommunicationConfigurationInfoDtoCommunicationConfigChannelsEnum>;
    /**
     * 
     * @type {string}
     * @memberof IUserCommunicationConfigurationInfoDto
     */
    notification_priority?: IUserCommunicationConfigurationInfoDtoNotificationPriorityEnum;
}

/**
* @export
* @enum {string}
*/
export enum IUserCommunicationConfigurationInfoDtoCommunicationConfigChannelsEnum {
    NOTIFICATION_CENTER = 'NOTIFICATION_CENTER',
    EMAIL = 'EMAIL',
    TEXT = 'TEXT'
}
/**
* @export
* @enum {string}
*/
export enum IUserCommunicationConfigurationInfoDtoNotificationPriorityEnum {
    IMPORTANT_ONLY = 'IMPORTANT_ONLY',
    INTERESTING = 'INTERESTING',
    ALL_NOTIFICATIONS = 'ALL_NOTIFICATIONS'
}


/**
 * Check if a given object implements the IUserCommunicationConfigurationInfoDto interface.
 */
export function instanceOfIUserCommunicationConfigurationInfoDto(value: object): value is IUserCommunicationConfigurationInfoDto {
    return true;
}

export function IUserCommunicationConfigurationInfoDtoFromJSON(json: any): IUserCommunicationConfigurationInfoDto {
    return IUserCommunicationConfigurationInfoDtoFromJSONTyped(json, false);
}

export function IUserCommunicationConfigurationInfoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IUserCommunicationConfigurationInfoDto {
    if (json == null) {
        return json;
    }
    return {
        
        'communication_config_channels': json['communication_config_channels'] == null ? undefined : new Set(json['communication_config_channels']),
        'notification_priority': json['notification_priority'] == null ? undefined : json['notification_priority'],
    };
}

export function IUserCommunicationConfigurationInfoDtoToJSON(json: any): IUserCommunicationConfigurationInfoDto {
    return IUserCommunicationConfigurationInfoDtoToJSONTyped(json, false);
}

export function IUserCommunicationConfigurationInfoDtoToJSONTyped(value?: IUserCommunicationConfigurationInfoDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'communication_config_channels': value['communication_config_channels'] == null ? undefined : Array.from(value['communication_config_channels'] as Set<any>),
        'notification_priority': value['notification_priority'],
    };
}

